<template>
    <div class="activities">
        <!-- 新增和查询 -->
        <el-form :inline="true">
             <!-- <el-form-item>
                <el-input
                    placeholder="请输入关键字"
                    width="100"
                    v-model="activitiesQuery"
                >
                </el-input>
            </el-form-item> -->
            <!-- <el-form-item>
                <el-select
                    v-model="activitiesQuery.checkStatus"
                    placeholder="请选择审核状态"
                    @change="searchByState"
                    clearable
                >
                    <el-option label="待审核" value="0"> </el-option>
                    <el-option label="审核通过" value="1"> </el-option>
                    <el-option label="审核未通过" value="2"> </el-option>
                </el-select>
            </el-form-item> -->
            <!-- <el-form-item>
                <el-button @click="getAllCourseList">查询</el-button>
                <el-button type="primary" @click="addOrUpdateHandle()"
                    >新增</el-button
                >
            </el-form-item> -->
        </el-form>
        <!-- 赛事信息列表展示 -->
        <el-table
            :data="activitiesList"
            style="width: 100%"
            v-loading="loading"
            border
            :default-sort="{ prop: 'sort', order: 'descending' }"
        >
            <el-table-column type="index" width="50" label="#" align="center"> </el-table-column>
            <el-table-column label="模板名称" align="center" min-width="350">
                <template slot-scope="scope">
                    <el-popover
                        placement="right"
                        width="400"
                        popper-class="poperTip"
                        trigger="hover"
                    >
                        <el-form
                            label-position="left"
                            inline
                            class="demo-table-expand"
                            label-width="100px"
                        >
                            <el-form-item label="赛事名称">
                                <span v-html="showcontent(scope.row.name)"></span>
                            </el-form-item>
                            <!-- <el-form-item label="活动描述">
                                <span>{{ scope.row.description }}</span>
                            </el-form-item> -->
                            <!-- <el-form-item label="图片地址">
                                <span>{{ scope.row.thumb }}</span>
                            </el-form-item> -->
                            <!-- <el-form-item label="外链地址">
                                <span>{{ scope.row.link }}</span>
                            </el-form-item>
                            <el-form-item label="活动开始时间">
                                <span>{{ scope.row.startTime }}</span>
                            </el-form-item>
                            <el-form-item label="活动结束时间">
                                <span>{{ scope.row.endTime }}</span>
                            </el-form-item>
                            <el-form-item label="创建时间">
                                <span>{{ scope.row.createTime }}</span>
                            </el-form-item>
                            <el-form-item label="更新时间">
                                <span>{{ scope.row.updateTime }}</span>
                            </el-form-item> -->
                        </el-form>

                        <el-link
                            class="overflow"
                            :underline="false"
                            slot="reference"
                        >
                            {{ scope.row.name }}
                        </el-link>
                    </el-popover>
                </template>
            </el-table-column>
            <!-- <el-table-column
                label="活动图片"
                prop="thu   mb_"
                align="center"
                width="130"
            >
                <template slot-scope="scope">
                    <div class="img-show">
                        <el-image
                            v-if="scope.row.thumb != null"
                            width="75%"
                            contain
                            class="image-slot"
                            :src="scope.row.thumb"
                            fit="contain"
                            :preview-src-list="[scope.row.thumb]"
                        ></el-image>
                        <div v-else slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </div>
                </template>
            </el-table-column> -->



            <!-- <el-table-column label="热度" align="center" width="70">
                <template slot-scope="scope">
                    <span>{{
                        scope.row.startTime.split(" ")[0] +
                        "—" +
                        scope.row.endTime.split(" ")[0]
                    }}</span>
                </template>
            </el-table-column> -->
            <el-table-column
                prop="heat"
                label="热度"
                width="100"
                align="center"
            >
            </el-table-column>
            <el-table-column prop="sort" label="排序" align="center" width="70">
                <template slot-scope="scope">
                    <el-input
                    class="e-input"
                        v-model.number="scope.row.sort"
                        @blur="updateSort(scope.row)"
                    ></el-input>
                </template>
            </el-table-column>
            <!-- <el-table-column
                prop="showStatus"
                label="状态"
                align="center"
                width="100"
            >
                <template slot-scope="scope">
                    <el-button
                        size="mini"
                        plain
                        class="padding-style"
                        :type="
                            scope.row.showStatus === '0' ? 'danger' : 'success'
                        "
                        @click="changeShow(scope.row)"
                    >
                        {{ scope.row.showStatus === "0" ? "不显示" : "显示" }}
                    </el-button>
                </template>
            </el-table-column> -->
            
            <!-- <el-table-column label="是否置顶" align="center" width="120">
                <template slot-scope="scope">
                    <el-button
                        size="size"
                        disable-transitions
                        class="padding-style"
                        type="primary"
                        plain
                        @click="changeTop(scope.row)"
                    >
                        {{ scope.row.isTop === "0" ? "不置顶" : "置顶" }}
                    </el-button>
                </template>
            </el-table-column> -->
            <el-table-column label="模板详情" width="280" align="center">
                <template  slot-scope="scope">
                    <el-button
                        type="primary"
                        size="mini"
                        plain
                        class="btns"
                        @click="addOrUpdateHandle(scope.row.id)"
                    >
                        模板详情
                    </el-button>
                    <!-- <el-button
                        type="primary"
                        size="mini"
                        plain
                        class="btns"
                        @click="deleteActivities(scope.row.id)"
                    >
                        删除
                    </el-button> -->

                    <!-- <router-link
                        class="
                            el-button
                            btns
                            el-button--primary el-button--mini
                            is-plain
                            btns
                        "
                        tag="button"
                        :to="{
                            name: 'detailSign',
                            params: {
                                id: scope.row.id,
                            },
                        }"
                        v-if="scope.row.checkStatus !== '0'"
                        >报名详情</router-link
                    > -->
                    <!-- <router-link
                        class="
                            el-button
                            btns
                            el-button--primary el-button--mini
                            is-plain
                            btns
                        "
                        tag="button"
                        :to="{
                            name: 'activitiesReview',
                            params: {
                                id: scope.row.id,
                            },
                        }"
                        >活动总览</router-link
                    > -->
                </template>
            </el-table-column>
        </el-table>
        <!-- 活动赛事列表分页器 -->
        <!-- <el-pagination
            background
            layout="prev, pager, next"
            :total="activitiesTotal"
            @current-change="pageChange"
            :page-size="activitiesQuery.limit"
            :current-page="activitiesQuery.page"
        >
        </el-pagination> -->
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update
            ref="addOrUpdateRef"
         
            v-if="addOrUpdateVisible"
        />
        <!-- 报名人员信息列表 -->
        <person-list ref="personRef" />
        <!-- 审核新添加列表的弹框 -->
        <!-- <check-status
            :check-query="checkQuery"
            ref="checkRef"
            @updateComputed="getActivitiesList"
        /> -->
    </div>
</template>

<script>
import { showcontent } from "@/utils/method.js";
import AddOrUpdate from "@/views/modules/config/child-components/activitytemplate-add-or-update";
import PersonList from "@/views/modules/config/child-components/person-list";
import { checkMixin } from "@/utils/mixin.js";
import CheckStatus from "@/views/modules/config/child-components/check-status";
export default {
    mixins: [checkMixin],
    components: {
        AddOrUpdate,
        PersonList,
        CheckStatus,
    },
    data() {
        return {
            // 查询赛事列表参数
            activitiesQuery: {
                limit: 10,
                page: 1,
                checkStatus: "",
            },
            // 审核状态参数
            checkQuery: {
                id: null,
                checkStatus: "1",
            },
            // 赛事列表数据
            activitiesList: [],
            addOrUpdateVisible: false,
            activitiesTotal: 0,
            loading: false,
        };
    },
    computed: {
        // 标签状态样式
        hotLabelStyle() {
            return (status) => {
                return status === "1"
                    ? ""
                    : status === "2"
                    ? "danger"
                    : status === "3"
                    ? "success"
                    : status === "4"
                    ? "warning"
                    : "info";
            };
        },
        // 标签状态样式
        hotLabelShow() {
            return (status) => {
                return status === "1"
                    ? "普通"
                    : status === "2"
                    ? "最热"
                    : status === "3"
                    ? "最新"
                    : status === "4"
                    ? "预告"
                    : "活动回顾";
            };
        },
        // 模式样式
        modelStyle() {
            return (status) => {
                return status === "1"
                    ? ""
                    : status === "2"
                    ? "danger"
                    : "warning";
            };
        },
        // 模式显示
        modelShow() {
            return (status) => {
                return status === "1"
                    ? "常规模式"
                    : status === "2"
                    ? "倒计时模式"
                    : "预告模式";
            };
        },
    },
    created() {
        // this.getActivitiesList();
        this.getAllCourseList()
    },
    methods: {
        showcontent,
        // 获取所有的视频列表数据
        getAllCourseList() {
            this.loading = true;
            this.$ajaxGet("/registrationTemplate/getList/open").then(
                ({ data }) => {
                    console.log('视频列表数据',data)
                    if (data.code === 0) {
                         this.loading = false;
                    this.activitiesList = data.data;
                    // this.activitiesTotal = parseInt(data.data.total);
                    }
                }
            );
        },
        // 获取赛事列表
        // getActivitiesList() {
        //     this.loading = true;
        //     this.$ajaxGet(
        //         "/registrationTemplate/getList/open"
        //     ).then(({ data }) => {
        //         if (data.code === 0) {
        //             // this.activitiesList = data.data;
        //             this.loading = false;
        //             this.activitiesList = data.data.records;
        //             this.activitiesTotal = parseInt(data.data.total);
        //         }
        //     });
        // },
        // 新增或修改活动赛事
        addOrUpdateHandle(id) {
            this.addOrUpdateVisible = true;
            this.$nextTick(() => {
                this.$refs.addOrUpdateRef.init(id);
            });
        },
        // 打开报名人员信息列表
        // personInfoList(item) {
        //     const { id, name } = item;
        //     this.$nextTick(() => {
        //         this.$refs.personRef.init({ id, name });
        //     });
        // },
        // 删除活动赛事
        // deleteActivities(id) {
        //     this.$confirm("此操作将永久删除该条目,是否继续?", "提示", {
        //         confirmButtonText: "确定",
        //         cancelButtonText: "取消",
        //         type: "warning",
        //     })
        //         .then(() => {
        //             this.$ajaxPost("/activities/delete", {}, { id }).then(
        //                 ({ data }) => {
        //                     if (data.code === 0) {
        //                         // this.getActivitiesList();
        //                         this.getAllCourseList()
        //                         this.$message({
        //                             type: "success",
        //                             message: "删除成功!",
        //                         });
        //                     }
        //                 }
        //             );
        //         })
        //         .catch(() => {
        //             this.$message({
        //                 type: "info",
        //                 message: "已取消删除",
        //             });
        //         });
        // },
        // 保存排序
        updateSort(item) {
            const { id, sort } = item;
            console.log(parseInt(id), sort);
            this.$ajaxPost("/activities/update/open", {
                id: parseInt(id),
                sort,
            }).then(({ data }) => {
                if (data.code === 0) {
                    this.$message.success("排序保存成功");
                }
            });
        },
        // 审核赛事活动状态
        // examineStatus(id) {
        //     this.checkQuery.id = id;
        //     this.$nextTick(() => {
        //         this.$refs.checkRef.init("/activities/update/open");
        //     });
        // },
        // 点击置顶/不置顶按钮
        // async changeTop(item) {
        //     let { id, isTop } = item;
        //     isTop = isTop === "1" ? "0" : "1";
        //     const { data } = await this.updateState({ id, isTop });
        //     if (data.code === 0) {
        //         item.isTop = isTop;
        //     }
        // },
        // 点击显示/不显示按钮
        // async changeShow(item) {
        //     let { id, showStatus } = item;
        //     showStatus = showStatus === "1" ? "0" : "1";
        //     const { data } = await this.updateState({ id, showStatus });
        //     if (data.code === 0) {
        //         item.showStatus = showStatus;
        //         this.getAllCourseList()
        //     }
        // },
        // 更新赛事活动封装函数
        // updateState(queryInfo) {
        //     return this.$ajaxPost("/activities/update/open", queryInfo);
        // },
        // 分页器页数改变事件
        // pageChange(val) {
        //     this.activitiesQuery.page = val;
        //     this.getActivitiesList();
        // },
        // 根据审核状态查询
        // searchByState(state) {
        //     this.activitiesQuery.checkStatus = state;
        //     // this.getActivitiesList();
        // },
    },
};
</script>

<style lang="less" scoped>
.e-input{
    /deep/.el-input__inner{
        text-align: center;
    }
}
.demo-table-expand {
    font-size: 0;
}
/deep/ .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}

.btns {
    padding: 5px 7px;
    a {
        color: #409eff;
        &:hover {
            color: #fff;
        }
    }
}
.overflow {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    display: inline-block;
    width: 100%;
}
.padding-style {
    padding: 5px 7px;
}
.img-show {
    display: flex;
    height: 40px;
    width: 100%;
    align-items: center;
    justify-content: center;
}
</style>